import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Conexiones from "./components/Conexiones";
import Token from "./components/Token";
import Configuracion from "./components/Configuracion";
import './App.css';

function App({ msalInstance }) {
  const [account, setAccount] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    console.log("🚀 App.jsx montado");

    const accounts = msalInstance.getAllAccounts();
    console.log("🔍 MSAL.getAllAccounts:", accounts);

    if (accounts.length === 0) {
      console.warn("⛔ No hay cuentas MSAL activas");
      setReady(true);
      return;
    }

    const selected = accounts[0];
    msalInstance.setActiveAccount(selected);
    console.log("✅ Cuenta activada:", selected.username);

    if (!selected.username.endsWith("@jaimeillanes.cl")) {
      console.warn("⛔ Dominio no autorizado:", selected.username);
      cerrarSesionMiddleware();
      return;
    }

    // ✅ Guardar usuario en localStorage
    localStorage.setItem("usuarioMicrosoft", selected.username);

    setAccount(selected);
    setReady(true);
  }, [msalInstance]);

  const cerrarSesionMiddleware = () => {
    console.log("🚪 Cerrando sesión...");
    document.cookie = "middleware_session=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;";
    msalInstance.setActiveAccount(null);
    setAccount(null);
    window.location.href = window.location.origin;
  };

  if (!ready) return <div>🔄 Validando cuenta...</div>;
  if (!account) return <div>🔐 Sin sesión válida</div>;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/conexiones" element={<Conexiones />} />
        <Route path="/token" element={<Token />} />
        <Route path="/configuracion" element={<Configuracion />} />
      </Routes>
    </Router>
  );
}

export default App;
